import React from 'react';
import { INFERENCE_MODE_OPTIONS } from '../aiModelConstants';
import { InferenceMode } from '../aiModelTypes';
import { StepProps } from './stepTypes';

const InferenceModeStep: React.FC<StepProps> = ({ form, isLight, patch }) => {
  return (
    <div className="space-y-3">
      <p className={`text-[11px] ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>
        Workflows will filter models by the modes they can invoke.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {INFERENCE_MODE_OPTIONS.map((opt) => {
          const active = form.inferenceMode === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => patch({ inferenceMode: opt.value as InferenceMode })}
              className={`text-left rounded-lg border px-3 py-3 transition-colors ${
                active
                  ? 'border-indigo-500 bg-indigo-500/10'
                  : isLight
                    ? 'border-neutral-200 bg-white hover:border-indigo-300'
                    : 'border-neutral-800 bg-neutral-900 hover:border-indigo-500/40'
              }`}
            >
              <div className={`text-xs font-semibold ${isLight ? 'text-neutral-900' : 'text-white'}`}>
                {active ? '✓ ' : ''}
                {opt.label}
              </div>
              <p className={`text-[11px] mt-1 ${isLight ? 'text-neutral-500' : 'text-gray-400'}`}>{opt.hint}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default InferenceModeStep;
